<script>
  let {
    /** @type {string | undefined} an optional label for the diver */
    label = '',
    /** @type {SvelteSnippet | undefined} pass any child to render as label */
    children,
    /** @type {'start'|'center'|'end'} */
    placement = 'start',
    class: css_class,
  } = $props();
</script>

<div class='divider {placement} {css_class}'>
  {#if !label && !children}
    <hr class="full-width" />
  {:else}
    {#if placement !== 'start'}<hr>{/if}
    {#if label && typeof label === 'string'} 
      <span class='text-control text-2'>{label}</span>
    {:else if children}
      {@render children()}
    {/if}
    {#if placement !== 'end'}<hr>{/if}
  {/if}
</div>

<style lang="postcss">
  div {
    cursor: default;
    align-items: center;
    margin: var(--size-2) 0;
    max-width: 100%;
    display: grid;
    gap: var(--size-3);
    /* Match ButtonLabel inline padding for alignment */
    --divider-label-padding: calc(var(--input-min-height, 32px) / 2 * 0.8);
    
    &.start {
      grid-template-columns: auto 1fr;
      
      /* Add padding to align label with ButtonLabel content */
      > span, > :not(hr) {
        padding-inline-start: var(--divider-label-padding);
        position: relative;
        
        /* Draw line extending through the padding area */
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          width: calc(var(--divider-label-padding) - var(--size-3) / 2);
          height: 1px;
          background: var(
            --divider-color,
            color-mix(
              in oklch,
              var(--color-foreground, var(--color-default-foreground)) 28%,
              transparent
            )
          );
        }
      }
    }
    
    &.center {
      grid-template-columns: 1fr auto 1fr;
    }
    
    &.end {
      grid-template-columns: 1fr auto;
    }
  }
  :global(.popover-content > .divider:first-child) {
    margin-top: 0;
  }

  hr {
    width: 100%;
    min-width: 4ch;
  }

  :global(hr.full-width) {
    grid-column: 1 / -1;
  }

  :global(.divider > *:not(hr)) {
    width: fit-content;
  }

  :global(.bg-accent .divider > hr) {
    --divider-color: var(--color-default-foreground);
  }
</style>
